var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.uploading
        ? _c(
            "v-sheet",
            { staticClass: "text-center align-center" },
            [
              _c("v-progress-circular", {
                attrs: {
                  size: 98,
                  width: 7,
                  color: "primary",
                  indeterminate: "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.uploading
        ? _c("v-sheet", { staticClass: "gery--text" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
          ])
        : _vm._e(),
      !_vm.uploading
        ? _c(
            "div",
            {
              staticClass: "rounded pa-3 max-width",
              style: {
                border: _vm.disabled
                  ? "none"
                  : "2px dashed var(--main-border-color)",
              },
              on: { dragover: _vm.fileDragover, drop: _vm.fileDrop },
            },
            [
              _c(
                "v-form",
                { attrs: { enctype: "multipart/form-data", method: "post" } },
                [
                  _c("v-file-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false",
                      },
                    ],
                    attrs: {
                      id: "fileInput",
                      "hide-input": "",
                      enctype: "multipart/form-data",
                    },
                    on: { change: _vm.chooseUploadFile },
                  }),
                ],
                1
              ),
              _vm.fileList.length
                ? _c(
                    "v-sheet",
                    { staticClass: "text-left align-center" },
                    _vm._l(_vm.fileList, function (item, index) {
                      return _c(
                        "v-list-item",
                        {
                          key: item.id,
                          staticClass: "rounded mt-2 pt-2 pb-2",
                          staticStyle: {
                            border: "1px solid var(--main-border-color)",
                          },
                          attrs: { "two-line": "" },
                        },
                        [
                          _c(
                            "v-list-item-avatar",
                            {
                              staticClass:
                                "pa-0 pt-2 pb-2 mt-0 mb-0 mr-1 text--secondary",
                              staticStyle: { border: "none" },
                              attrs: { size: "50", tile: "" },
                              on: {
                                click: function ($event) {
                                  _vm.curImageIndex = index
                                  _vm.showImageBox = true
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  size: "24",
                                  fill: "#0f46c1",
                                  iconClass:
                                    _vm.getType(item.filename) == "jpg"
                                      ? "filetype-jpg"
                                      : _vm.getType(item.filename) == "csv"
                                      ? "filetype-csv"
                                      : _vm.getType(item.filename) == "doc"
                                      ? "filetype-doc"
                                      : _vm.getType(item.filename) == "gif"
                                      ? "filetype-gif"
                                      : _vm.getType(item.filename) == "png"
                                      ? "filetype-png"
                                      : _vm.getType(item.filename) == "xls"
                                      ? "filetype-xls"
                                      : _vm.getType(item.filename) == "docx"
                                      ? "filetype-doc"
                                      : _vm.getType(item.filename) == "xlsx"
                                      ? "filetype-xls"
                                      : _vm.getType(item.filename) == "pdf"
                                      ? "filetype-pdf"
                                      : _vm.getType(item.filename) == "ppt"
                                      ? "filetype-ppt"
                                      : _vm.getType(item.filename) == "jpeg"
                                      ? "filetype-jpg"
                                      : "filetype-file",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(item.filename)),
                              ]),
                              _c(
                                "v-list-item-subtitle",
                                [
                                  _c("v-chip", { attrs: { "x-small": "" } }, [
                                    _vm._v(_vm._s(_vm.$byteconvert(item.size))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          !_vm.disabled
                            ? _c(
                                "v-list-item-action",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { small: "", icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteItem(item.id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons-round" },
                                        [_vm._v("delete")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
              (_vm.single ? _vm.fileList.length == 0 : true)
                ? _c("v-sheet", { staticClass: "text-center align-center" }, [
                    _vm.fileList.length == 0 && !_vm.disabled
                      ? _c("div", { staticClass: "text-center" }, [
                          _c(
                            "i",
                            {
                              staticClass:
                                "material-icons-round md-72 text--secondary lighten-2",
                            },
                            [_vm._v("backup")]
                          ),
                        ])
                      : _vm._e(),
                    _vm.fileList.length == 0 && !_vm.disabled
                      ? _c(
                          "div",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "text-capitalize",
                                attrs: {
                                  width: "50%",
                                  color:
                                    "primary lighten-2  pl-12 pr-12 primary--text",
                                  depressed: "",
                                  rounded: "",
                                },
                                on: { click: _vm.toChoose },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "label_essweb_update_components_browseBtnLabel"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.disabled && 0
                      ? _c("div", { staticClass: "pt-2 text--secondary" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message_essweb_rosterRecord_dialog_canBeExportInLabel"
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    !_vm.disabled
                      ? _c(
                          "div",
                          { staticClass: "pt-2 text--secondary" },
                          [
                            0
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message_essweb_rosterRecord_dialog_templateExportInLabel"
                                      )
                                    ) + " "
                                  ),
                                ])
                              : _vm._e(),
                            _c(
                              "v-btn",
                              {
                                staticClass:
                                  "\n            primary--text\n            text-decoration-underline text-capitalize\n            ma-0\n            pa-0\n            pl-1\n            pr-1\n            mt-n1\n            align-center\n          ",
                                attrs: {
                                  text: "",
                                  small: "",
                                  rounded: "",
                                  depressed: "",
                                  color: "primary",
                                },
                                on: { click: _vm.toUrl },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "label_essweb_rosterRecord_dialog_templateForDownloadLabel"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }